import receiveTelephone from '@/services/receive-telephone.service'

export default {
	async getReceiveTelephones({ dispatch }, data) {
		return await receiveTelephone
			.getReceiveTelephones(data)
			.then((response) => {
				if (response.success && response.data) {
					return Promise.resolve(response.data)
				} else {
					dispatch('alertError', response.message, { root: true })
					return Promise.reject(response.message)
				}
			})
			.catch(({ response }) => {
				dispatch('alertError', response.data.message, { root: true })
				return Promise.reject(false)
			})
	},

	async createOrUpdateReceiveTelephone({ dispatch }, data) {
		return await receiveTelephone
			.createOrUpdateReceiveTelephone(data)
			.then((response) => {
				if (response.success && response.data) {
					dispatch('alertSuccess', response.message, { root: true })
				} else {
					dispatch('alertError', response.message, { root: true })
					return Promise.reject(response.message)
				}
			})
			.catch(({ response }) => {
				dispatch('alertError', response.data.message, { root: true })
				return Promise.reject(false)
			})
	},

	async getReceiveTelephone({ dispatch }, id) {
		return await receiveTelephone
			.getReceiveTelephone(id)
			.then((response) => {
				if (response.success && response.data) {
					return Promise.resolve(response.data)
				} else {
					dispatch('alertError', response.message, { root: true })
					return Promise.reject(response.message)
				}
			})
			.catch(({ response }) => {
				dispatch('alertError', response.data.message, { root: true })
				return Promise.reject(false)
			})
	},

	async deleteReceiveTelephone({ dispatch }, id) {
		return await receiveTelephone
			.deleteReceiveTelephone(id)
			.then((response) => {
				if (response.success) {
					dispatch('alertSuccess', response.message, { root: true })
				} else {
					dispatch('alertError', response.message, { root: true })
					return Promise.reject(response.message)
				}
			})
			.catch(({ response }) => {
				dispatch('alertError', response.data.message, { root: true })
				return Promise.reject(false)
			})
	},

	async createOrUpdateCustomer({ dispatch }, data) {
		return await receiveTelephone
			.createOrUpdateCustomer(data)
			.then((response) => {
				if (response.success && response.data) {
					dispatch('alertSuccess', response.message, { root: true })
					return Promise.resolve(response.data)
				} else {
					dispatch('alertError', response.message, { root: true })
					return Promise.reject(response.message)
				}
			})
			.catch(({ response }) => {
				dispatch('alertError', response.data.message, { root: true })
				return Promise.reject(false)
			})
	}
}
